import Cookies from 'js-cookie';

export const ProductRecommendations = {
  mounted() {
    const id = this.el.dataset.id;
    let ngglobal = Cookies.get('ngglobal') ?? '';
    let ngglobalInterval = null;
    let time = 0;

    function getNGG(self) {
      time += 250;
      ngglobal = Cookies.get('ngglobal') ?? '';

      if (ngglobal || time >= 2000) {
        clearInterval(ngglobalInterval);
        self.pushEventTo(`#product_recommendations_${id}`, 'get_product_recommendations', {
          ngglobal
        });
      }
    }

    if (ngglobal) {
      this.pushEventTo(`#product_recommendations_${id}`, 'get_product_recommendations', {
        ngglobal
      });
    } else {
      ngglobalInterval = setInterval(getNGG, 250, this);
    }
  }
};
